/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DynamodbTableRestoreDestination } from '../models/DynamodbTableRestoreDestination';
import { RestoreMethod } from '../models/RestoreMethod';

export class RestoreDynamoDBTableRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': DynamodbTableRestoreDestination;
  'restoreMethod'?: RestoreMethod;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "DynamodbTableRestoreDestination",
      "format": ""
    },
    {
      "name": "restoreMethod",
      "baseName": "restoreMethod",
      "type": "RestoreMethod",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreDynamoDBTableRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



